import React, { useEffect, useState } from 'react'
import MobileHeader from '../../components/header/MobileHeader'
import LoginHeader from '../../components/header/LoginHeader'
import Breadcrumb from '../../components/breadcrumb'
import Footer from '../../components/footer'
import Gotop from '../../components/gotop'
import Setting from './Setting'
import LoginMobileHeader from '../../components/header/LoginMobileHeader'
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader'
import CRMobileHeader from '../../components/header/CRMobileHeader'
import InstituteHeader from '../../components/header/InstituteHeader'
import CRHeader from '../../components/header/CRHeader'
import NonLoginHeader from '../../components/header/NonLoginHeader'

const Settings = () => {
  const [isShowMobile, setShowMobile] = useState(false);

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);
  const module = localStorage.getItem('Module')
  return (
    <>
      {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
          module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
              <MobileHeader handleMobile={handleMobile} />}
      {module === 'Candidate' ? <LoginHeader handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteHeader handleMobile={handleMobile} /> :
          module === 'Company' ? <CRHeader handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRHeader handleMobile={handleMobile} /> :
              <NonLoginHeader handleMobile={handleMobile} />}

      <div className="pt-70">
        <Setting />
        {/* <Footer /> */}
        <Gotop />
        </div>
      </>
      )
}

      export default Settings